<template lang="pug">
    .hzDialogCover.tips(v-if="msg && msg.length > 0")
        .hzDialog.tips-container(:class="tipsType")
            i.tips-icon.fa(:class="[iconCls]")
            .tips-content(v-html="msg")
            .tips-close(v-on:click="remove") ×
</template>

<script>
    export default {
        name: 'hz-tips',
        props: {
            time: { type: Number, default: 0 },
            msg: String,
            tipsType: String
        },

        methods: {
            remove() {
                $(this.$el).remove();
            }
        },
        computed: {
            iconCls(){
                switch(this.tipsType){
                    case 'success':
                        return 'fa-check-circle'
                    case ('error' || 'red') :
                        return 'fa-times-circle'
                    case 'warning':
                        return 'fa-exclamation-circle'
                    default:
                        return 'fa-info-circle'
                }
            }
        },
        
        mounted() {
            if(this.time && this.time > 0) {
                setTimeout( e => {
                    this.remove();
                }, this.time);
            }
        }
    }
</script>
<style lang="stylus" scoped>
    
        
</style>



// WEBPACK FOOTER //
// src/tips.vue